enum Metrics {
    ARK_BUTTONS = 'ark-buttons',
    ARK_DWELL_TIME_SKU = 'ark-dwell-time-sku',
    ARK_NO_INTERACTIONS_SKU = 'ark-no-interactions-sku',
    ARK_SESSIONS_SKU = 'ark-sessions-sku',
    ARK_TOP_STORES = 'ark-top-stores',
    DEVICES_ONLINE = 'devices-online',
    DEVICES_TYPES = 'devices-types',
    EVENTSPACE_CONTENT_TOP = 'eventspace-content-top',
    EVENTSPACE_DWELLTIMELINE = 'eventspace-dwelltimeline',
    EVENTSPACE_INTERACTIONS_GROUPED = 'eventspace-interactions-grouped',
    EVENTSPACE_INTERACTIONS = 'eventspace-interactions',
    EVENTSPACE_PRODUCTS_TOP = 'eventspace-products-top',
    EVENTSPACE_STORES_TOP = 'eventspace-stores-top',
    GROUP = 'group',
    INRUN_CONTENT_TOP = 'inrun-content-top',
    INRUN_CONTENT = 'inrun-content',
    INRUN_DWELLTIME = 'inrun-dwelltime',
    INRUN_DWELLTIMELINE = 'inrun-dwelltimeline',
    INRUN_INTERACTIONS = 'inrun-interactions',
    INRUN_SESSIONS_COUNT = 'inrun-sessions-count',
    INRUN_STORES_TOP = 'inrun-stores-top',
    LARGEVISION_DEVICES_ONLINE = 'largevision-devices-online',
    LARGEVISION_DWELLTIMELINE = 'largevision-dwelltimeline',
    LARGEVISION_INTERACTIONS_PLAYLISTS = 'largevision-interactions-playlists',
    LARGEVISION_INTERACTIONS_PRODUCTS = 'largevision-interactions-products',
    LARGEVISION_INTERACTIONS_TOTAL = 'largevision-interactions-total',
    LARGEVISION_PLAYLIST_TOP = 'largevision-playlist-top',
    LARGEVISION_SESSIONS_TIMELINE = 'largevision-sessions-timeline',
    LARGEVISION_STORES_TOP = 'largevision-stores-top',
    LIFTLEARN_DWELLTIME_AVERAGE = 'liftlearn-dwelltime-average',
    LIFTLEARN_DWELLTIME_BOUNCERATE = 'liftlearn-bouncerate',
    LIFTLEARN_DWELLTIME_TOTAL_PRODUCTS = 'liftlearn-dwelltime-total-products',
    LIFTLEARN_DWELLTIME_TOTAL = 'liftlearn-dwelltime-total',
    LIFTLEARN_DWELLTIMELINE_PRODUCTS = 'liftlearn-dwelltimeline-products',
    LIFTLEARN_DWELLTIMELINE = 'liftlearn-dwelltimeline',
    LIFTLEARN_TOP_PRODUCTS = 'liftlearn-top-products',
    LIFTLEARN_TOP_STORES = 'liftlearn-top-stores',
    LIFTLEARN_TOTAL_INTERACTIONS = 'liftlearn-interactions',
    MEDIA_LATEST = 'media-latest',
    MEDIA_SCHEDULED_NEXT = 'media-scheduled-next',
    MINIVISION_CONTENT_TOP = 'minivision-content-top',
    MINIVISION_DWELLTIMELINE = 'minivision-dwelltimeline',
    MINIVISION_INTERACTIONS_GROUPED = 'minivision-interactions-grouped',
    MINIVISION_INTERACTIONS = 'minivision-interactions',
    MINIVISION_SOUNDBARS_TOP = 'minivision-soundbars-top',
    MINIVISION_STORES_TOP = 'minivision-stores-top',
    NOTES_LATEST = 'notes-latest',
    PLAYLISTS_LATEST = 'playlists-latest',
    PLAYLISTS_SCHEDULED_NEXT = 'playlists-scheduled-next',
    WFH_DEVICES_ONLINE = 'wfh-devices-online',
    WFH_DWELLTIMELINE = 'wfh-dwelltimeline',
    WFH_INTERACTIONS_PLAYLISTS = 'wfh-interactions-playlists',
    WFH_INTERACTIONS_PRODUCTS = 'wfh-interactions-products',
    WFH_INTERACTIONS_TOTAL = 'wfh-interactions-total',
    WFH_PLAYLIST_TOP = 'wfh-playlist-top',
    WFH_SESSIONS_TIMELINE = 'wfh-sessions-timeline',
    WFH_STORES_TOP = 'wfh-stores-top',
    WOW_BUTTONS = 'wow-buttons',
    WOW_DWELLTIME = 'wow-dwelltime',
    WOW_DWELLTIMELINE_PRODUCTS = 'wow-dwelltimeline-products',
    WOW_DWELLTIMELINE = 'wow-dwelltimeline',
    WOW_INSTALLATIONS_TOP = 'wow-installations-top',
    WOW_MEDIA_TOP = 'wow-media-top',
    WOW_SESSIONS_COUNT = 'wow-sessions-count',
    WOW_STORES_TOP = 'wow-stores-top',
    JLP_BUTTONS = 'jlp-buttons',
    JLP_DWELL_TIME_SKU = 'jlp-dwell-time-sku',
    JLP_SESSIONS_SKU = 'jlp-sessions-sku',
    EVENTSPACE2_CONTENT_TOP = 'eventspace2-content-top',
    EVENTSPACE2_DWELLTIMELINE = 'eventspace2-dwelltimeline',
    EVENTSPACE2_INTERACTIONS_GROUPED = 'eventspace2-interactions-grouped',
    EVENTSPACE2_STORES_TOP = 'eventspace2-stores-top',
    EVENTSPACE2_DEVICES_ONLINE = 'eventspace2-devices-online',
    CDD_LAST_DOWNLOAD = 'cdd-last-download'
}

export default Metrics
